const sC = typeof structuredClone === 'function';

export function clone(arg = {}, transferables = []) {
  let result;

  if (sC) {
    result = structuredClone(arg, transferables);
  } else {
    result = JSON.parse(JSON.stringify(arg));

    for (const key of transferables) {
      result[key] = arg[key];
    }
  }

  return result;
}

export function merge(a = {}, b = {}) {
  const result = clone(a);

  for (const key of Reflect.ownKeys(b)) {
    result[key] = Object.assign(clone(result[key] || {}), b[key]);
  }
}
